module.exports = __webpack_public_path__ + "static/media/27OCHA13.fe4870f4.jpg";